import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Wrench } from 'lucide-react';

export default function Privacidad() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-300" data-testid="privacidad-page">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-slate-500 hover:text-slate-300 text-sm mb-8">
          <ArrowLeft className="w-4 h-4" /> Volver
        </button>

        <div className="flex items-center gap-2 mb-8">
          <Wrench className="w-6 h-6 text-amber-500" />
          <span className="font-barlow text-lg font-bold text-amber-500 uppercase">Talleres PRO</span>
        </div>

        <h1 className="font-barlow text-3xl font-bold text-slate-50 uppercase mb-8">Aviso de Privacidad</h1>

        <div className="prose prose-invert prose-sm max-w-none space-y-6 text-slate-400 leading-relaxed">
          <p><strong className="text-slate-200">Ultima actualizacion:</strong> {new Date().toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' })}</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">1. Responsable del tratamiento</h2>
          <p>Talleres PRO (en adelante "la Plataforma") es responsable del tratamiento de los datos personales que usted nos proporcione, los cuales seran protegidos conforme a la Ley Federal de Proteccion de Datos Personales en Posesion de los Particulares.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">2. Datos personales que recabamos</h2>
          <p>Recabamos los siguientes datos: nombre completo, correo electronico, numero telefonico, nombre del negocio, direccion del negocio, informacion fiscal (RFC), datos de clientes y vehiculos que usted registre en la plataforma.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">3. Finalidades del tratamiento</h2>
          <p>Sus datos personales seran utilizados para: proveer los servicios de la plataforma, gestionar su cuenta, enviar comunicaciones relacionadas con el servicio, procesar pagos y facturacion, mejorar nuestros servicios.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">4. Proteccion de datos</h2>
          <p>Implementamos medidas de seguridad tecnicas, administrativas y fisicas para proteger sus datos personales contra dano, perdida, alteracion, destruccion o acceso no autorizado. Toda la informacion se transmite de forma encriptada.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">5. Derechos ARCO</h2>
          <p>Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos personales. Para ejercer estos derechos, puede contactarnos a traves de la plataforma.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">6. Uso de cookies</h2>
          <p>La plataforma utiliza cookies y tecnologias similares para mejorar la experiencia del usuario, mantener la sesion activa y realizar analisis de uso.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">7. Modificaciones al aviso</h2>
          <p>Nos reservamos el derecho de efectuar modificaciones al presente aviso de privacidad. Cualquier cambio sera notificado a traves de la plataforma.</p>
        </div>
      </div>
    </div>
  );
}
